<template>
  <section id="SMS" class="section-item">
    <h1>E-mail</h1>

    <section id="api-E-mail-GetEmailMessagesId">
      <h2>{{ $t("title.email") }} - {{ $t("title.consult_by_id") }}</h2>
      <p>{{ $t("email.get_message_by_id_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/email/messages/:id</code></pre>
      </div>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.message_id") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-E-mail-PostEmailMessages">
      <h2>E-mail - {{ $t("title.send_message") }}</h2>
      <p>{{ $t("email.send_email_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/email/messages</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON (c/ Corpo)
        </button>
        <button
          @click="selectedTab = 'json2'"
          :class="{ active: selectedTab === 'json2' }"
        >
          JSON (c/ ID do Template)
        </button>
      </div>
      <pre v-if="selectedTab === 'json'">
        <code class="language-json">{
  "from": "noreply@victormartins.me",
  "messages": [
    {
      "to": "vctormartins1@gmail.com",
      "substitutions": {"{first_name}": "V.", "{last_name}": "M."},
      "ext_id": "1"
    },
    {
      "to": "victor@tew.one",
      "substitutions": {}
    }
  ],
  "sandbox_mode": false,
  "body": "Bem-vindo, {last_name}",
  "subject": "Assunto, {first_name}",
  "reply_email": "suporte@omni.chat",
  "from_name": "Victor Martins",
  "status_callback": "https://host.domain/status",
  "message_callback": "https://host.domain/msg"
}</code>
      </pre>

      <pre v-if="selectedTab === 'json2'">
        <code class="language-json">{
  "from": "noreply@victormartins.me",
  "messages": [
    {
      "to": "vctormartins1@gmail.com",
      "substitutions": {"{first_name}": "V.", "{last_name}": "M."},
      "ext_id": "1"
    },
    {
      "to": "victor@tew.one",
      "substitutions": {}
    }
  ],
  "sandbox_mode": false,
  "template_id": "123e4567-e89b-12d3-a456-426614174000",
  "subject": "Assunto, {first_name}",
  "reply_email": "suporte@omni.chat",
  "from_name": "Victor Martins",
  "status_callback": "https://host.domain/status",
  "message_callback": "https://host.domain/msg"
}
        </code>
      </pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>from</td>
            <td>String</td>
            <td>{{ $t("table.sender_email") }}</td>
          </tr>
          <tr>
            <td>messages</td>
            <td>Array</td>
            <td>{{ $t("table.recipients_and_substitutions") }}</td>
          </tr>
          <tr>
            <td>to</td>
            <td>String</td>
            <td>{{ $t("table.recipient_emails") }}</td>
          </tr>
          <tr>
            <td>substitutions</td>
            <td>Object</td>
            <td>{{ $t("table.variables_object") }}</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.email_body") }}</td>
          </tr>
          <tr>
            <td>sandbox_mode</td>
            <td>Boolean</td>
            <td>{{ $t("table.test_mode") }}</td>
          </tr>
          <tr>
            <td>template_id</td>
            <td>String</td>
            <td>{{ $t("table.template_id-email") }}</td>
          </tr>
          <tr>
            <td>subject</td>
            <td>String</td>
            <td>{{ $t("table.email_subject") }}</td>
          </tr>
          <tr>
            <td>reply_email</td>
            <td>String</td>
            <td>{{ $t("table.reply_email") }}</td>
          </tr>
          <tr>
            <td>from_name</td>
            <td>String</td>
            <td>{{ $t("table.sender_name") }}</td>
          </tr>
          <tr>
            <td>ext_id</td>
            <td>String</td>
            <td>
              {{ $t("table.external_id-wpp") }}
            </td>
          </tr>
          <tr>
            <td>status_callback</td>
            <td>String</td>
            <td>{{ $t("table.optional_status_callback_url") }}</td>
          </tr>
          <tr>
            <td>message_callback</td>
            <td>String</td>
            <td>{{ $t("table.optional_response_callback_url") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section
      id="api-E-mail-GetEmailMessagesDirectionDirectionCreated_atCreated_at"
    >
      <h2>E-mail - {{ $t("title.list_messages") }}</h2>
      <p>{{ $t("email.list_email_messages_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/email/messages?direction=:direction&created_at=:created_at</code></pre>
      </div>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>direction</td>
            <td>String</td>
            <td>{{ $t("table.message_direction_response") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("general.created_at") }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "WppComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-section {
  margin-top: 30px;
  text-align: start;
}

.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
